module.exports = __webpack_public_path__ + "img/paystack.5f74e6ab.svg";